export default __webpack_public_path__ + "static/media/discover-logo.40d93048.png";